import { LogEntry as LogEntryT, LogEntryUser } from 'lib-shared-legacy-types';

import { automatedActivityTypes } from '../activityTypes.utils';

export const getLogEntryAuthorName = (entry: LogEntryT): string =>
  entry.author?.name ||
  entry.author?.email ||
  entry.author?.phone_number ||
  entry.author?.id ||
  '';

export const getLogEntryUserName = (user: LogEntryUser): string =>
  user?.name || user?.email || user?.phone_number || user?.id || '';

export const isAutomaticEvent = (entry: LogEntryT): boolean =>
  automatedActivityTypes.includes(entry.activity_type);
